import React from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Paper,
  Stack,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { BodyText } from "../../../widgets/TemplatePreview";

const ShowMediaMessage = ({ data, onOpen, preview = false }) => {
  const renderPreview = () => {
    const { type, link } = data;
    if (type === "image") {
      return (
        <Box
          component="img"
          src={link}
          alt="media preview"
          sx={{
            width: "100%",
            maxHeight: 300,
            objectFit: "contain",
            borderRadius: 1,
            my: 1,
          }}
        />
      );
    }

    if (type === "video") {
      /* ---------- VIDEO ------------------------------------------------ */
      return (
        <Box sx={{ my: 1 }}>
          <Box
            component="video"
            src={link}
            controls
            sx={{ maxHeight: 300 }}
            preload="metadata"
            style={{ width: "100%", borderRadius: 8 }}
          />
        </Box>
      );
    }

    if (type === "document") {
      /* ---------- PDF / DOC ------------------------------------------- */
      return (
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            px: 1.5,
            py: 1,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            my: 1,
          }}
        >
          <PictureAsPdfOutlinedIcon color="action" fontSize="large" />
          <MuiLink
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ wordBreak: "break-all" }}
          >
            {link.split("/").pop()}
          </MuiLink>
        </Stack>
      );
    }

    /* ---------- FALLBACK (unknown type) ------------------------------- */
    return (
      <Stack direction="row" alignItems="center" spacing={1} sx={{ my: 1 }}>
        <InsertDriveFileOutlinedIcon color="action" />
        <MuiLink
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {link}
        </MuiLink>
      </Stack>
    );
  };

  return (
    <Container maxWidth="md">
      <Paper sx={{ p: 2 }} variant="outlined">
        {!preview && (
          <Stack my={1} direction="row" spacing={1} flexWrap="wrap">
            {data.triggerText.map((item) => (
              <Chip key={item} variant="outlined" label={item} clickable />
            ))}
          </Stack>
        )}
        {renderPreview()}
        {data.caption && <BodyText>{data.caption}</BodyText>}
        {!preview && (
          <Stack direction="row" justifyContent="end">
            <Button
              onClick={() => onOpen?.()}
              startIcon={<AddIcon />}
              variant="outlined"
              size="small"
            >
              Add trigger
            </Button>
          </Stack>
        )}
      </Paper>
    </Container>
  );
};

export default ShowMediaMessage;
